import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CheckboxInput from './Input';
import LabelText from '../../LabelText';

const CB1R1O = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component, checkedValues, formFields} = props;
	const {fieldname, required, option_display, options, has_other_option, other_option_label} = form_component;

	useEffect(() => { // to be updated after render
		i18n.changeLanguage(props.lang);
	}, []);

	return (
		<div className={`flex-grow-1 form-group ${required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			<div className={`label_box ${option_display === '1R1O' ? 'label-full' : 'label-50'}`}>
				{(() => {
					const components = [];

					(options || []).map((option, index) => {
						components.push(
							<CheckboxInput
								key={`input-${index}`}
								lang={props.lang}
								form_component={form_component}
								formFields={formFields}
								option={option}
								checkedValues={checkedValues}
							/>
						);
					});

					if (has_other_option) {
						components.push(
							<CheckboxInput
								key={`input-other`}
								lang={props.lang}
								formFields={formFields}
								form_component={form_component}
								option={{
									label: other_option_label,
									value: 'other'
								}}
								checkedValues={checkedValues}
							/>
						);
					}

					return components;
				})()}
			</div>
		</div>
	);
}

export default CB1R1O;